export enum SOCKET_CONVERSATION_ACTIONS {
  ONLINE = 'ONLINE',
  OFFLINE = 'OFFLINE',
  INIT = 'INIT',
}
